import { gql } from '@apollo/client'

import { usePaginatedQuery } from 'hooks'

const FORM_LIST_QUERY = gql`
  query UserList($offset: Int, $max: Int) {
    formList(offset: $offset, max: $max) {
      totalCount
      results {
        id
        name
        beginDate
        endDate
        sector {
          name
        }
        status
      }
    }
  }
`

export function useFormListQuery(options) {
  return usePaginatedQuery(FORM_LIST_QUERY, options)
}
